export default __webpack_public_path__ + "static/media/tdd.e0c5b8df.png";